import clsx from 'clsx';
import deepEqual from 'fast-deep-equal';
import { ReactNode } from 'react';

import styles from './Diff.module.scss';


export interface DiffValueProps<TValue> {
    originalValue: TValue;
    updatedValue: TValue;
    isCreate?: boolean;
    isDelete?: boolean;
    renderValue?: (value: TValue) => ReactNode;
    hideIfUnchanged?: boolean;
}

export function DiffValue<TValue>({
    originalValue, updatedValue, renderValue: renderValueProp, isCreate, isDelete
}: DiffValueProps<TValue>) {
    const valueChanged = !deepEqual(originalValue, updatedValue);

    const renderValue = (value: TValue) => renderValueProp?.(value) || value as unknown as ReactNode;

    return (
        <>
            {!isCreate && (
                <div
                    className={clsx({
                        [styles.oldDiffValue]: valueChanged || isDelete
                    })}
                >
                    {renderValue(originalValue)}
                </div>
            )}

            {valueChanged && !isDelete && (
                <div className={styles.newDiffValue}>
                    {renderValue(updatedValue)}
                </div>
            )}
        </>
    );
}
